/**
 * @generated SignedSource<<146d3e44671a64662ecec7b7a3fbc383>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ReportMenuQuery$variables = {
  reportId: string;
};
export type ReportMenuQuery$data = {
  readonly reportById: {
    readonly resolutionProgress: number | null;
  } | null;
};
export type ReportMenuQuery = {
  variables: ReportMenuQuery$variables;
  response: ReportMenuQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "reportId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "reportId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resolutionProgress",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportMenuQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Report",
        "kind": "LinkedField",
        "name": "reportById",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReportMenuQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Report",
        "kind": "LinkedField",
        "name": "reportById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8f1cb0f6f8ed3fb7f19e18d8815ba4a9",
    "id": null,
    "metadata": {},
    "name": "ReportMenuQuery",
    "operationKind": "query",
    "text": "query ReportMenuQuery(\n  $reportId: ID!\n) {\n  reportById(id: $reportId) {\n    resolutionProgress\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8aaad1e07fae5b8e0ba97751db6925c5";

export default node;
